export function useCache() {
  const isCacheEnabled = {
    pushXGrantCredentialsMap: false
  };
  // Set true to enable cache and false to disable cache
  const setCachingStatus = (key, value = true) => {
    isCacheEnabled[key] = value;
  };
  const getCachingStatus = (key) => {
    return isCacheEnabled[key];
  };
  // Set all caches value to false.
  const clearCache = () => {
    Object.keys(isCacheEnabled).forEach((key) => (isCacheEnabled[key] = false));
  };

  return {
    setCachingStatus,
    getCachingStatus,
    clearCache
  };
}
